import React, { useState } from "react"
import { BsSearch } from "react-icons/bs"
import type { SearchProps } from "./search"

const SearchTrigger = () => {
  const [Search, setSearch] = useState<React.ComponentType<SearchProps> | null>(
    null,
  )
  const [searchVersion, setSearchVersion] = useState(0)

  const openSearch = async () => {
    if (!Search) {
      const module = await import("./search")
      setSearch(() => module.default)
    }
    setSearchVersion(version => version + 1)
  }

  return (
    <>
      <button
        className="search-trigger-button"
        type="button"
        aria-label="サイト内を検索"
        onClick={openSearch}
      >
        <BsSearch aria-hidden="true" />
      </button>
      {Search && <Search key={searchVersion} initiallyOpen />}
    </>
  )
}

export default SearchTrigger
